import React, { useEffect, useState } from 'react'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField } from '@mui/material'
import { trackActivity } from '../../../utils/mixpanel'
import { globalGetService, globalPostService } from '../../../utils/globalApiServices'
import { checkApiStatus, getGlobalCookie } from '../../../utils'
import { useSnackbar } from 'notistack'
import AutocompleteCreatable from '../../../shared_elements/components/AutocompleteCreatable'
import { regexConstants } from '../../../constants/regEx'
import { getEmailListApi } from '../apiService'
import { avationPlcInstance } from '../../../shared_elements'

const SendMail = ({ onToggleFn, invoiceDetails, getInvoice, getTimeLineResponseBack }) => {
    const isSummaryInvoice = invoiceDetails?.is_summary_invoice === true;
    const lesseeId=isSummaryInvoice? invoiceDetails?.to?.id || null : invoiceDetails?.lessee?.id || null;
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState({
        to_emails_list: isSummaryInvoice
            ? (invoiceDetails?.send_email_content?.to_emails_list ? invoiceDetails?.send_email_content?.to_emails_list : [])
            : (invoiceDetails?.to_emails_list ? invoiceDetails?.to_emails_list : []),
        cc_emails_list: isSummaryInvoice
            ? (invoiceDetails?.send_email_content?.cc_emails_list ? invoiceDetails?.send_email_content?.cc_emails_list : [])
            : (invoiceDetails?.cc_emails_list ? invoiceDetails?.cc_emails_list : []),
        subject: isSummaryInvoice
            ? (invoiceDetails?.send_email_content?.email_subject ? invoiceDetails?.send_email_content?.email_subject : null)
            : (invoiceDetails?.email_subject ? invoiceDetails?.email_subject : null),
        format: invoiceDetails?.shared_invoices?.format ? invoiceDetails?.shared_invoices?.format : (avationPlcInstance ? "excel" : "pdf"),
        signature: invoiceDetails?.shared_invoices ? invoiceDetails?.shared_invoices?.signature : null,
        content: isSummaryInvoice
            ? (invoiceDetails?.send_email_content?.email_content ? invoiceDetails?.send_email_content?.email_content : null)
            : (invoiceDetails?.email_content ? invoiceDetails?.email_content : null),
        invoiceDetails: invoiceDetails || {},
    });
    const [error, setError] = useState({});
    const [dropDownLoader, setDropDownLoader] = useState({ user: false })
    const [user, setUser] = useState([]);
    const userinfo = JSON.parse(getGlobalCookie('lessorAccess'))

    useEffect(() => {
        getUserList({lessee_ids:lesseeId});
    }, [])

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Share Invoice`, page_type: page_type, })
    }

    const onFieldChange = (key, value) => {
        if (Array.isArray(value)) {
            const unique = [];

            value.forEach((item) => {
                const email = item?.label || item;
                if (!unique.includes(email) && regexConstants.email.test(email)) {
                    unique.push(email);
                }
            });

            const formatted = unique.map((e) => ({ label: e }));
            setData({ ...data, [key]: formatted });
        }
        else {
            setData({ ...data, [key]: value });
        }
    };


    const getUserList = (query={}) => {
        setDropDownLoader(prev => ({ ...prev, user: true }));
        globalGetService(getEmailListApi(query))
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, user: false }));
                if (checkApiStatus(response)) {
                    setUser(response?.data?.data);
                }
            })
    }

    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    const onSendMail = () => {
        let validationInputs = {};
        validationInputs = {
            subject: data?.subject ? "" : "A subject line is required so the recipient knows what this email is about",
            content: data?.content ? "" : "Write a message to accompany the invoice before sending",
            to_emails_list: "",
            cc_emails_list: ""
        };

        if (!data?.to_emails_list || data?.to_emails_list?.length === 0) {
            validationInputs.to_emails_list = "Enter at least one recipient email address to send the invoice";
        } else {
            const invalidEmails = data.to_emails_list.filter(
                (item) => !regexConstants.email.test(item?.label || item)
            );

            if (invalidEmails.length > 0) {
                validationInputs.to_emails_list = "Please enter valid Email(s)";
                enqueueSnackbar(
                    `The following email address(es) are invalid: ${invalidEmails
                        .map(email => email?.label || email)
                        .join(', ')}`,
                    {
                        variant: "error",
                        anchorOrigin: { horizontal: "right", vertical: "top" }
                    }
                );
            }
        }

        if (data?.cc_emails_list?.length) {
            const invalidCcEmails = data.cc_emails_list.filter(
                (item) => !regexConstants.email.test(item?.label || item)
            );

            if (invalidCcEmails.length > 0) {
                validationInputs.cc_emails_list = "Please enter valid CC Email(s)";

                enqueueSnackbar(
                    `The following CC email address(es) are invalid: ${invalidCcEmails
                        .map(email => email?.label || email)
                        .join(', ')}`,
                    {
                        variant: "error",
                        anchorOrigin: { horizontal: "right", vertical: "top" }
                    }
                );
            }
        }

        let payload = Object.assign({}, data)

        payload = {
            to_emails_list: payload?.to_emails_list ? payload?.to_emails_list?.map((item) => item?.label || item) : [],
            cc_emails_list: payload?.cc_emails_list ? payload?.cc_emails_list?.map((item) => item?.label || item) : [],
            subject: payload?.subject ? payload?.subject : null,
            content: payload?.content ? payload?.content : null,
            format: payload?.format ? payload?.format : "pdf",
            signature: payload?.signature ? payload?.signature : null,
            ...(isSummaryInvoice
                ? { summary_invoice: payload?.invoiceDetails?.id ? payload?.invoiceDetails?.id : null }
                : { invoice: payload?.invoiceDetails?.id ? payload?.invoiceDetails?.id : null }
            ),
            shared_by: userinfo?.id ? userinfo?.id : null
        }

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            globalPostService('/lease/shared_invoices', payload)
                .then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleFn()
                        getInvoice()
                        getTimeLineResponseBack()
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Send Invoice`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: payload, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Send Invoice`, error_msg: response?.data?.message, item_id: null, payload: payload, response: response?.data })
                    }
                });
        } else {
            setError(validationInputs)
        }
    };

    return (
        <>
            <Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' maxWidth='md' fullWidth open={true} >
                <DialogTitle sx={{ m: 0, p: 2,pl:3 }} className='dialog-header' id="customized-dialog-title">
                    Send Invoice
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <AutocompleteCreatable
                                options={user
                                    ?.filter(email => !data.to_emails_list?.some(i => (i.label || i) === email))
                                    ?.map(email => ({ label: email }))
                                }
                                paramsKey='to_emails_list'
                                optionKey='label'
                                label='To'
                                value={data?.to_emails_list || []}
                                onFieldChange={(e, paramsKey, newValue) => onFieldChange('to_emails_list', newValue)}
                                required={true}
                                multiple={true}
                                noOptionsText={dropDownLoader?.user ? "loading..." : 'No options, please type to create new'}
                                placeholder={data?.to_emails_list?.length === 0 ? 'Enter Email(s)' : ''}
                                error={error?.to_emails_list}
                                helperText={error?.to_emails_list || ''}
                                resetErrorKey={() => onRestErrorKey("to_emails_list")}
                            />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <AutocompleteCreatable
                                options={data?.cc_emails_list || []}
                                paramsKey='cc_emails_list'
                                optionKey='label'
                                label='CC'
                                value={data?.cc_emails_list || []}
                                onFieldChange={(e, paramsKey, newValue) => onFieldChange('cc_emails_list', newValue)}
                                required={false}
                                multiple={true}
                                noOptionsText={dropDownLoader?.user ? "loading..." : 'No options, please type to create new'}
                                placeholder={data?.cc_emails_list?.length === 0 ? 'Enter CC Email(s)' : ''}
                                error={error?.cc_emails_list}
                                helperText={error?.cc_emails_list || ''}
                                resetErrorKey={() => onRestErrorKey("cc_emails_list")}
                            />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                id="subject"
                                label="Subject"
                                variant="outlined"
                                size='small'
                                required
                                value={data?.subject || ''}
                                onChange={(e) => { onFieldChange('subject', e.target.value.trimStart()) }}
                                onFocus={() => onRestErrorKey("subject")}
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 50 } }}
                                error={error?.subject}
                                helperText={error?.subject}
                            />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                id="content"
                                label="Content"
                                variant="outlined"
                                size='small'
                                margin='normal'
                                required
                                value={data?.content || ''}
                                onChange={(e) => onFieldChange('content', e.target.value.trimStart())}
                                onFocus={() => onRestErrorKey("content")}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 1000 } }}
                                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                fullWidth
                                multiline
                                rows={4}
                                error={error?.content}
                                helperText={error?.content}
                            />
                        </Grid>
                        {!isSummaryInvoice && (
                            <Grid item md={12} xs={12}>
                                <FormControl>
                                    <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="file-format" defaultValue={avationPlcInstance ? "excel" : "pdf"} value={data?.format || (avationPlcInstance ? "excel" : "pdf")} className='radio-color' >
                                        <FormControlLabel value="pdf" checked={data?.format === "pdf"} control={<Radio size="small" onChange={() => onFieldChange("format", "pdf")} />} label="PDF Format" />
                                        <FormControlLabel value="excel" checked={data?.format === "excel"} control={<Radio size="small" onChange={() => onFieldChange("format", "excel")} />} label="Excel Format" />
                                        <FormControlLabel value="docs" checked={data?.format === "docs"} control={<Radio size="small" onChange={() => onFieldChange("format", "docs")} />} label="Docs Format" />
                                        {/* <FormControlLabel value="csv" checked={data?.format === "csv"} control={<Radio size="small" onChange={() => onFieldChange("format", "csv")} />} label="CSV Format" /> */}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        )}
                        {!isSummaryInvoice && (
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id="email_signature"
                                    label="Email Signature"
                                    variant="outlined"
                                    size='small'
                                    margin='normal'
                                    value={data?.signature || ''}
                                    onChange={(e) => { onFieldChange('signature', e.target.value.trimStart()) }}
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 500 } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    fullWidth
                                    multiline
                                    rows={4}
                                />
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ marginRight: "15px" }}>
                    <Button className='cancel-btn' variant='outlined' size='small' disabled={isLoading} onClick={() => { onToggleFn(); handleItemClicked('Cancel Button') }}> Cancel </Button>
                    <Button variant='contained' disabled={isLoading} className='btn-primary' size='small' onClick={() => { onSendMail(); handleItemClicked('Send Button') }} >
                        {isLoading ? <CircularProgress size={24} /> : 'Send'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default SendMail